<template>
  <div>
    <autocomplete v-model="searchQuery" :static-items="staticItems" :disabled="!remote && staticItems && staticItems.length === 0" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
      <template #item="props">
        <strong>{{ props.item.name }}</strong>
        <span v-if="props.item.vehicle_type_group">({{ props.item.vehicle_type_group.external_id || props.item.vehicle_type_group.reference }})</span>
      </template>
    </autocomplete>
  </div>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'VehicleTypeAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    remote: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50',
      staticItems: this.vehicleTypeGroupVehicleTypes || null
    }
  },
  watch: {
    preQuery(val) {
      this.searchQuery = val || ''
    },
    vehicleTypeGroupVehicleTypes: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (!this.remote) {
          console.log('Updating vehicleTypeGroupVehicleTypes', val, oldVal)
          this.staticItems = val
          if (oldVal && oldVal.length !== 0 && JSON.stringify(val) !== JSON.stringify(oldVal) && !this.preQuery) {
            this.searchQuery = ''
          }
        }
      }
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Type to search...')
    }
  },
  methods: {
    onInputChange(query) {
      if (!this.remote && this.staticItems) {
        if (this.staticItems.length > 0) {
          if (query.trim().length > 0) {
            return this.staticItems.filter((item) => {
              return item.name.toLowerCase().includes(query.toLowerCase()) || item.external_id.toLowerCase().includes(query.toLowerCase())
            })
          } else {
            this.$emit('selected', null)
            return this.staticItems
          }
        } else {
          return this.staticItems
        }
      } else {
        let params = {
          includes: ['vehicle_type_group'],
          sort: [
            {
              key: 'name',
              direction: 'asc'
            },
            {
              key: 'id',
              direction: 'asc'
            }
          ],
          filter_groups: [
            {
              filters: [
                ['name', 'ct', query.trim()]
              ]
            }
          ]
        }

        if (query.trim().length >= this.minCharacter) {
          return new Promise(resolve => {
            this.$http.get(this.$appConfig.api.baseUrl + 'vehicle-types', {params: params})
              .then(response => {
                resolve(response.body.data)
              })
          })
        } else if (query.trim().length === 0) {
          this.$emit('selected', null)
        }
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.name
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
